import { render, staticRenderFns } from "./ColorModuleTable.vue?vue&type=template&id=3d131494&scoped=true"
import script from "./ColorModuleTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorModuleTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorModuleTable.vue?vue&type=style&index=0&id=3d131494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d131494",
  null
  
)

export default component.exports